import React, { useState, useEffect } from 'react';
import { _subscribe } from '../../toastBus';
import styles from './Toast.module.scss';

const ICONS = {
    success: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
    ),
    error: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
    ),
    warning: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
        </svg>
    ),
    info: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
        </svg>
    ),
};

export default function Toast() {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        return _subscribe(toast => {
            setToasts(p => [...p, toast]);
            setTimeout(() => {
                setToasts(p => p.filter(t => t.id !== toast.id));
            }, 4500);
        });
    }, []);

    if (!toasts.length) return null;

    return (
        <div className={styles.container}>
            {toasts.map(t => (
                <div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
                    <span className={styles.icon}>{ICONS[t.type] || ICONS.info}</span>
                    <span className={styles.message}>{t.message}</span>
                    <button
                        className={styles.closeBtn}
                        onClick={() => setToasts(p => p.filter(x => x.id !== t.id))}
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>
            ))}
        </div>
    );
}
